import { render } from "./EliminaDestino.vue?vue&type=template&id=2b6a2bee&scoped=true"
import script from "./EliminaDestino.vue?vue&type=script&lang=js"
export * from "./EliminaDestino.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./EliminaDestino.vue?vue&type=style&index=1&id=2b6a2bee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6a2bee"]])

export default __exports__